/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Task_Combine_DescInputs */

const en_pc_online_task_combine_desc = /** @type {(inputs: Pc_Online_Task_Combine_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open All tools, then Combine files. Add the PDFs in the order you want and combine them. Each source file becomes a bookmark in the result.`)
};

const zh_pc_online_task_combine_desc = /** @type {(inputs: Pc_Online_Task_Combine_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开 All tools，然后选择 Combine files。按想要的顺序添加 PDF 并合并。每个源文件都会成为结果中的一个书签。`)
};

/**
* | output |
* | --- |
* | "Open All tools, then Combine files. Add the PDFs in the order you want and combine them. Each source file becomes a bookmark in the result." |
*
* @param {Pc_Online_Task_Combine_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_task_combine_desc = /** @type {((inputs?: Pc_Online_Task_Combine_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Task_Combine_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_task_combine_desc(inputs)
	return zh_pc_online_task_combine_desc(inputs)
});
export { pc_online_task_combine_desc as "pc.online.task.combine.desc" }